"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VARIANTS = void 0;
const VARIANTS = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  paragraph: 'p',
  support: 'p',
  supportForm: 'p',
  button: 'p',
  action: 'p',
  form: 'p',
  title: 'h2',
  subtitle1: 'h4',
  subtitle2: 'h5',
  body1: 'p',
  body2: 'p',
  caption: 'p',
  overline: 'p',
  textParagraph: 'p',
  textSupport: 'p',
  labelAction: 'p',
  labelButton: 'p',
  labelForm: 'p'
};
exports.VARIANTS = VARIANTS;